import { companyProfileSchema } from './company-profile';

import type { CompanyProfile } from './company-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type GenerateCompanyDescription = () => Promise<Result<CompanyProfile, unknown>>;

const timeout = 60_000;

export const createGenerateCompanyDescription = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): GenerateCompanyDescription => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.post(companyProfileSchema, {
            pathname: `/company-profile/generate/description`,
            requestOptions: {
                timeout,
            },
        });
    };
};
